import React, { useEffect, useState, useContext } from "react";
import Page from "../../components/DefaultPage/DefaultPage";
import { useTranslation } from "react-i18next";
import { AddObjectiveCard, ObjectiveCard } from "../../components/Cards/Cards";
import classes from "./Objectives.module.css";
import AuthContext from "../../store/AuthContext";
import LoadingPage from "../LoadingPage/LoadingPage";

export default function Objectives() {
  const [tg, i18n] = useTranslation("global");
  const [isLoading, setIsLoading] = useState(false);
  const [loadedObjectives, setLoadedObjectives] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("valid"); // "valid" ou "all"

  const authCtx = useContext(AuthContext);
  const ip = process.env.REACT_APP_SERVER_IP;
  const port = process.env.REACT_APP_SERVER_PORT;
  const protocol = process.env.REACT_APP_SERVER_PROTOCOL;

  const serverPath = `${protocol}://${ip}:${port}`;
  const objectivesPath =
    selectedFilter === "valid"
      ? `${serverPath}/objectives`
      : `${serverPath}/all-objectives`;

  useEffect(() => {
    setIsLoading(true);

    const postData = {
      tokenID: authCtx.tokenID,
      refreshToken: authCtx.refreshToken,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    };

    fetch(objectivesPath, requestOptions)
      .then((response) => response.json())
      .then((objectives) => {
        setIsLoading(false);
        const objValues = Object.values(objectives);
        setLoadedObjectives(objValues);
        const allCoordinates = objValues.map((obj) => obj.coordinates);
        localStorage.setItem("objectiveCoordinates", JSON.stringify(allCoordinates));
        console.log("user id is this: " + authCtx.userId);
      })
      .catch((error) => {
        console.error("Error fetching objectives:", error);
        setIsLoading(false);
      });
  }, [objectivesPath]);

  if (isLoading) {
    return (
      <section>
        <LoadingPage />
      </section>
    );
  }

  return (
    <Page>
      <section className={classes.cards} style={{ marginTop: "5rem" }}>
        {/* Cabeçalho com botão de adicionar + filtro */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            marginBottom: "1rem",
          }}
        >
          <ul style={{ margin: 0 }}>
            <li>
              <AddObjectiveCard image="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Plus_symbol.svg/1200px-Plus_symbol.svg.png" />
            </li>
          </ul>

          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <label htmlFor="filterSelect" style={{ fontWeight: "bold" }}>
              Filtrar:
            </label>
            <select
              id="filterSelect"
              value={selectedFilter}
              onChange={(e) => setSelectedFilter(e.target.value)}
              style={{
                padding: "0.5rem",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontWeight: "bold",
              }}
            >
              <option value="valid">Válidos</option>
              <option value="all">Todos</option>
            </select>
          </div>
        </div>

        {/* Lista de objetivos ou mensagem de ausência */}
        {loadedObjectives.length === 0 ? (
          <p style={{ fontWeight: "bold", textAlign: "center", marginTop: "2rem" }}>
            {selectedFilter === "valid"
              ? "Não existe nenhum objetivo ativo no momento"
              : "Não existe nenhum objetivo listado"}
          </p>
        ) : (
          <ul>
            {loadedObjectives.map((objective) => (
              <li key={objective.id}>
                <ObjectiveCard
                  key={objective.id}
                  wallet={objective.wallet}
                  id={objective.id}
                  repCounter={objective.repCounter}
                  title={objective.title}
                  adminID={objective.adminID}
                  coolDownTime={objective.coolDownTime}
                  coordinates={objective.coordinates}
                  radius={objective.radius}
                  creationDate={objective.creationDate}
                  description={objective.description}
                  dueDate={objective.dueDate}
                  qrID={objective.qrID}
                  maxScans={objective.maxScans}
                  pointValue={objective.pointValue}
                  refreshRate={objective.refreshRate}
                  hideOnMobile={objective.hideOnMobile}
                />
              </li>
            ))}
          </ul>
        )}
      </section>
    </Page>
  );
}
